import { Children, cloneElement, isValidElement, useRef } from 'react';
import { FormMessage } from '../common';
import { Stack } from '../Stack';
import { FieldHeaderComponent } from './Field';
import { CompoundFieldProps } from './FieldProps';
import { FieldContainer } from './style';

const CompoundField = ({
    children,
    label,
    name,
    required,
    captionIconHandler,
    captionIconWithTooltip,
    helper,
    size,
    inputSpacing = '100',
    ...other
}: CompoundFieldProps) => {
    const fieldWrapperRef = useRef<HTMLDivElement>(null);

    return (
        <FieldContainer ref={fieldWrapperRef} {...other}>
            <FieldHeaderComponent
                name={name}
                label={label}
                required={required}
                captionIconWithTooltip={captionIconWithTooltip}
                captionIconHandler={captionIconHandler}
                fieldWrapperRef={fieldWrapperRef}
            />
            <Stack spacing={inputSpacing} distribution="stretch">
                {Children.map(children, (child) =>
                    isValidElement(child)
                        ? cloneElement(child, {
                              ...child.props,
                              insideCompoundField: true,
                          })
                        : child
                )}
            </Stack>
            <>
                {helper ? (
                    <FormMessage size={size} data-test-message-helper>
                        {helper}
                    </FormMessage>
                ) : null}
            </>
        </FieldContainer>
    );
};

export default CompoundField;
